module.exports = __webpack_public_path__ + "static/media/horn-soli-p1.1dfd1389.jpg";